import { IInsights } from '../insights';

export const formatAdsFilterData = (insights: IInsights) => {
  let formattedAdsets: any[] = [];
  let formattedAds: any[] = [];
  const campaigns =
    insights.campaigns?.map(campaign => {
      const adSets = campaign.adSets?.map((adset: any) => {
        const ads = adset?.ads?.map((ad: any) => ({
          ...ad,
          isActive: true,
          adsetAttributes: adset.attributes,
          campaignAttributes: campaign.attributes,
        }));
        formattedAds = [...formattedAds, ...(ads ?? [])];
        return {
          ...adset,
          isActive: true,
          ads,
          campaignAttributes: campaign.attributes,
        };
      });
      formattedAdsets = [...formattedAdsets, ...(adSets ?? [])];
      return { ...campaign, isActive: true, adSets };
    }) ?? [];

  return { campaigns, adSets: formattedAdsets, ads: formattedAds };
};

export const formatWebsiteFilterData = (insights: IInsights) => {
  let formattedViews: any[] = [];
  let formattedPages: any[] = [];
  const properties: any[] =
    (insights as any).properties?.map((property: any) => {
      const views = property.views?.map((view: any) => {
        const pages = view?.pages?.map((page: any) => ({
          ...page,
          isActive: true,
          viewAttributes: view.attributes,
          propertyAttributes: property.attributes,
        }));
        formattedPages = [...formattedPages, ...(pages ?? [])];
        return {
          ...view,
          isActive: true,
          pages,
          propertyAttributes: property.attributes,
        };
      });
      formattedViews = [...formattedViews, ...(views ?? [])];
      return { ...property, isActive: true, views };
    }) ?? [];

  return {
    properties,
    views: formattedViews,
  };
};
